/**
 * @generated SignedSource<<63bdd56587d4872a1ea6c763a1e3e5d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ActionsCell237BadPattern$data = {
  readonly canViewProjectConfig: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ActionsCell">;
  readonly " $fragmentType": "ActionsCell237BadPattern";
};
export type ActionsCell237BadPattern$key = {
  readonly " $data"?: ActionsCell237BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActionsCell237BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ActionsCell237BadPattern",
  "selections": [
    {
      "alias": "canViewProjectConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "VIEW_PROJECT_CONFIG"
        }
      ],
      "concreteType": "JiraProjectAction",
      "kind": "LinkedField",
      "name": "action",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ],
      "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "ActionsCell"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "6dd3cd9addffda8b70c0380a3937b782";

export default node;
